export type OrganizationQueryParams = {
  organizationId: string;
  tab?: OrganizationTab;
  vendorId?: string;
  subTab?: OrganizationVendorsSubTab;
  auditId?: string;
  auditTab?: AuditTab;
  taskId?: string;
  locationId?: string;
  ticketId?: string;
  actionItemId?: string;
  contactId?: string;
  employeeId?: string;
  invoiceId?: string;
  sibContractId?: string;
};

export enum OrganizationTab {
  Overview = 'overview',
  Comments = 'comments',
  BillPay = 'billPay',
  SubsidiaryOrg = 'subsidiaryOrg',
  Locations = 'locations',
  Documents = 'documents',
  Invoices = 'invoices',
  Vendors = 'vendors',
  VendorAccounts = 'vendorAccounts',
  OnlineAccess = 'onlineAccess',
  SpendSavings = 'spendSavings',
  Work = 'work',
  SibContracts = 'sibContracts',
  Audits = 'audits',
  FutureOpportunities = 'futureOpportunities',
  Billing = 'billing',
  Services = 'services',
  Users = 'users',
  Vsr = 'vsr',
  Revenue = 'revenue',
  Reports = 'reports',
}

export enum OrganizationVendorsSubTab {
  Information = 'information',
  Contacts = 'contacts',
}

export enum OrganizationUsersSubTab {
  ClientContacts = 'clientContacts',
  SibEmployees = 'sibEmployees',
}

export enum AuditTab {
  SpendSavings = 'spendSavings',
  VendorContacts = 'vendorContacts',
  ManagingLocations = 'managingLocations',
  Documents = 'documents',
  VendorAccount = 'vendorAccount',
  VendorArchivePocs = 'vendorArchivePocs',
  LinkedAudits = 'linkedAudits',
  ActivityHistory = 'activityHistory',
  Comments = 'comments',
}

export enum BreadcrumbSegmentsIds {
  Organizations = 'organizations',
  Audits = 'audits',
}
